import {
  eventsTypesSearchSchema,
  eventsTypesViewColumns,
  mapEventsTypesViewQuery,
} from "./EventsTypesView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getEventsTypes } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface EventsTypesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function EventsTypesView(props: EventsTypesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={eventsTypesViewColumns}
      schema={eventsTypesSearchSchema}
      mapQuery={mapEventsTypesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getEventsTypes, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("CalendarEventsTypes", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("CalendarEventsTypes", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default EventsTypesView;
